export const useTooltip = (label, position = 'bottom', offset = { x: 0, y: 0 }) => {
    return {
      'data-tooltip': label,
      'data-tooltip-position': position,
      'data-tooltip-offset': JSON.stringify(offset)
    };
  };